export function isNullOrUndefined(element) {
  return typeof element === 'undefined' || element === null;
}
